import React from 'react';
import { Link } from 'react-router-dom';
import HeroImage from '../../images/hero-new.jpg';
import InsuranceBanner from '../InsuranceBanner/InsuranceBanner';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Hero2 = () => {
    const isMobile = window.innerWidth < 768;
    
    return (
        <>
            <InsuranceBanner />
            <div 
                style={{
                    backgroundImage: `url(${HeroImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: isMobile ? '10% center' : 'center center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '100vh',
                    position: 'relative',
                    width: '100%',
                    display: 'block'
                }}
            >
                {/* Dark overlay */}
                <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1
            }} />
            
            {/* Content */}
            <div style={{
                position: 'relative',
                zIndex: 2,
                padding: isMobile ? '350px 20px 60px' : '200px 20px 150px',
                minHeight: isMobile ? '500px' : '700px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
                <div style={{maxWidth: '1200px', margin: '0 auto', width: '100%'}}>
                    <div style={{
                        maxWidth: '600px',
                        marginLeft: isMobile ? 'auto' : 'auto',
                        marginRight: isMobile ? 'auto' : '0',
                        textAlign: isMobile ? 'center' : 'right'
                    }}>
                        <h2 style={{
                            color: 'white',
                            fontSize: isMobile ? '36px' : '60px',
                            lineHeight: '1.2',
                            marginBottom: '20px',
                            fontFamily: 'Montserrat, sans-serif',
                            textAlign: isMobile ? 'center' : 'right'
                        }}>
Your Path to <br /> Optimal Health                        </h2>
                        <p style={{
                            color: 'white',
                            fontSize: isMobile ? '18px' : '18px',
                            marginBottom: '15px',
                            lineHeight: '1.5',
                            textAlign: isMobile ? 'center' : 'right'
                        }}>
                            Combining interventional therapies and regenerative medicine for the best possible outcomes
                        </p>
                        <p style={{
                            color: 'white',
                            fontSize: isMobile ? '16px' : '16px',
                            opacity: 0.9,
                            marginBottom: '30px',
                            textAlign: isMobile ? 'center' : 'right'
                        }}>
                            Medical Director: Dr. Eugene G. Pereira, MD • ABA-PM • FIPP • ABIPP
                        </p>
                        <div style={{textAlign: isMobile ? 'center' : 'right'}}>
                            <Link 
                                onClick={ClickHandler} 
                                to="/contact" 
                                style={{
                                    background: 'linear-gradient(135deg, #1E63FF 0%, #0EA1FF 100%)',
                                    color: 'white',
                                    padding: isMobile ? '12px 24px' : '12px 30px',
                                    borderRadius: '25px',
                                    display: 'inline-block',
                                    textDecoration: 'none',
                                    fontSize: isMobile ? '16px' : '18px'
                                }}
                            >
                                Schedule Your Consultation
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            
            </div>
        </>
    );
};

export default Hero2;